/**
 * @description 工作台
 * @author cjs1992
 * @date 2020-09-02 11:22:21
 */
import { request } from "@/api/axios.js";
/**
 * @name findWork
 * @description 获取待办/已办
 * @param {
 *  pageNum  当前页
 *  pageSize 每页条数
 *  resultType  0 待办 1 已办
 * }
 * @return {}
 * @author cjs1992
 * @date 2020-09-02 11:22:48
 */
export function findWork(data = {}, config = {}) {
  return request({
    method: "post",
    url: `/portal-ywtb/web/process/findWork`,
    data,
    ...config,
    nativeForm: true
  });
}
/**
 * @name findMessage
 * @description 获取待阅/已阅
 * @param {
 *  pageNum  当前页
 *  pageSize 每页条数
 *  resultType  0 待办 1 已办
 * }
 * @return {}
 * @author cjs1992
 * @date 2020-09-02 11:26:45
 */
export function findMessage(data = {}, config = {}) {
  return request({
    method: "post",
    url: `/portal-ywtb/web/message/findMessage`,
    data,
    ...config,
    nativeForm: true
  });
}



// WEBPACK FOOTER //
// ./src/api/workBench.js